import { render, staticRenderFns } from "./globalMapping.vue?vue&type=template&id=684ff06f&scoped=true"
import script from "./globalMapping.vue?vue&type=script&lang=js"
export * from "./globalMapping.vue?vue&type=script&lang=js"
import style0 from "./globalMapping.vue?vue&type=style&index=0&id=684ff06f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684ff06f",
  null
  
)

export default component.exports